const aboutConfig = {
  education: [
    { degree: 'Ph.D., Industrial & Manufacturing Engineering', institution: 'North Dakota State University, USA', year: 'Conferred August 2025', detail: 'Thesis: Enhancing Resilience in Energy Networks: A Multilayer Network and Machine Learning Approach' },
    { degree: 'MS, Computer Science', institution: 'Abasyn University, Pakistan', year: 'Conferred August 2019', detail: 'Thesis: Enhanced Detection Mechanism for Application-Layer DDoS Attacks using Machine Learning' },
    { degree: 'M.Sc., Computer Science', institution: 'University of Malakand, Pakistan', year: 'Conferred March 2014', detail: 'Gold Medal for academic distinction' },
  ],
};

export default aboutConfig;
